export type ResetPasswordResult = {
    success: boolean;
    reason?: 'invalid-token' | 'password-rejected' | 'request-failed';
    errorMessage?: string;
};

export type ResetPasswordMutationResult = {
    data: {
        resetPassword: boolean | null;
    };
};

export const resetPasswordMutation = `
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(resetPasswordToken: $token, newPassword: $password)
  }
`;